import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { COMMON_ROUTE } from "@obg/ngx.common";
import { ConfigService } from "@obg/ngx.global";

@Injectable({ providedIn: "root" })
export class LoginConfigService {
	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientCommon & ObgConfigFeAdaptiveClientCore>
	) {}

	getChangePasswordTokenEndpoint(): string {
		return this.configService.get(
			(x) => x.core.auth.endpoints!.changePasswordToken,
			"v1/forgottenpasswords/:forgotPasswordToken/"
		);
	}

	getResetPasswordByEmailEndpoint(): string {
		return this.configService.get((x) => x.core.auth.endpoints!.forgotPassword, "v1/forgottenpasswords/");
	}

	getResetPasswordBySmsEndpoint(): string {
		return this.configService.get((x) => x.core.auth.endpoints!.forgotPasswordSms, "");
	}

	getResetPasswordBySmsEnabled(): boolean {
		return this.configService.get((x) => x.core.auth.resetPasswordBySmsEnabled, false);
	}

	getExcludedRefererRouteNames(): string[] {
		return this.configService.get(
			(x) => x.common.registration.excludedRefererRouteNames,
			[
				COMMON_ROUTE.privacyPolicy,
				COMMON_ROUTE.cookiePolicy,
				COMMON_ROUTE.termsAndConditions.root,
				COMMON_ROUTE.groupCompanies,
				COMMON_ROUTE.complaints,
			]
		);
	}

	isSgaEnabled(): boolean {
		return this.configService.get((x) => x.common.isSgaEnabled, false);
	}
}
